import {ACTION_TYPES} from "../../../core/consts";
import {AnalyticsEventHandler} from "../../../infrastructure/handlers/analytics-event-handler";
import {
  WebsiteModuleBolaoFloatingButtonRemoveEvent
} from "../models/bolao/website-module.bolao.floating-button.remove-event";

export class WebsiteModuleFloatingButtonRemoveEventHandler extends AnalyticsEventHandler {
  type = ACTION_TYPES.floatingButtonRemoveEvent;

  async action(params) {
    const sendParams = {
      ...params,
      source: this.getScreen(this.state.currentLinkModel?.name),
    }

    const event: WebsiteModuleBolaoFloatingButtonRemoveEvent = new WebsiteModuleBolaoFloatingButtonRemoveEvent(sendParams);

    this.analyticsService.createEvent(event);
  }
}
